<template>
    <div class="column is-one-fifth">
        <aside class="menu">
            <p class="menu-label">{{ translate("notification_center.step_category.compose_notification") }}</p>
            <ul class="menu-list">
                <Step :step-name="STEP_CHOOSE_SOURCE_EVENTS" :step-text="translate('notification_center.step.choose_source_events')" />
                <Step :step-name="STEP_TYPE_OF_NOTIFICATION" :step-text="translate('notification_center.step.type_of_notification')" />
                <Step :step-name="STEP_FILTER_RECEIVERS" :step-text="translate('notification_center.step.filter_receivers')" />
                <Step :step-name="STEP_NOTIFICATION_CONTENT" :step-text="translate('notification_center.step.content_of_notification')" />
            </ul>
            <p class="menu-label">{{ translate("notification_center.step_category.overview") }}</p>
            <ul class="menu-list">
                <Step :step-name="STEP_REVIEW_RECEIVERS" :step-text="translate('notification_center.step.review_receivers')" />
                <Step :step-name="STEP_COST_CALCULATION" :step-text="translate('notification_center.step.cost_calculation')" />
            </ul>
            <p class="menu-label">{{ translate("notification_center.step_category.schedule") }}</p>
            <ul class="menu-list">
                <Step :step-name="STEP_SCHEDULE_SENDING" :step-text="translate('notification_center.step.choose_time_of_sending')" />
            </ul>
        </aside>
    </div>
</template>

<script>
    import { mapState } from "vuex";
    import {
        STEP_CHOOSE_SOURCE_EVENTS,
        STEP_COST_CALCULATION,
        STEP_FILTER_RECEIVERS,
        STEP_NOTIFICATION_CONTENT,
        STEP_REVIEW_RECEIVERS,
        STEP_SCHEDULE_SENDING,
        STEP_TYPE_OF_NOTIFICATION,
    } from "../consts";
    import Step from "./Step";
    import translatorMixin from "../../Common/translatorMixin";

    export default {
        name: "steps-menu",
        components: { Step },
        mixins: [translatorMixin],
        computed: {
            ...mapState("main", ["activeStep"]),
        },
        created() {
            this.STEP_CHOOSE_SOURCE_EVENTS = STEP_CHOOSE_SOURCE_EVENTS;
            this.STEP_TYPE_OF_NOTIFICATION = STEP_TYPE_OF_NOTIFICATION;
            this.STEP_FILTER_RECEIVERS = STEP_FILTER_RECEIVERS;
            this.STEP_NOTIFICATION_CONTENT = STEP_NOTIFICATION_CONTENT;
            this.STEP_REVIEW_RECEIVERS = STEP_REVIEW_RECEIVERS;
            this.STEP_COST_CALCULATION = STEP_COST_CALCULATION;
            this.STEP_SCHEDULE_SENDING = STEP_SCHEDULE_SENDING;
        },
        methods: {},
    };
</script>

<style scoped></style>
